'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';

import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export const Certificates = ({ images }: { images: { url: string; name: string }[] }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="w-full grid grid-cols-3 gap-4 md:gap-5 lg:gap-6">
        {images.map((image, index) => (
          <Image 
            onClick={handleOpenGallery(images, index)}
            key={index}
            src={image.url}
            alt={resolveImageAlt(image, undefined)}
            height={0}
            width={0}
            className='col-span-1 w-full h-auto object-contain cursor-pointer'
            sizes='250px'
          />
        ))}
      </div>
    </>
  );
};
